<template>
    <div class="vehicle-addon-price">
        <span>{{ addon.priceLabel }}</span>
        <span v-if="addon.priceType !== PRICE_TYPE_INCLUDED" class="vehicle-addon-price__per-night">
            {{ $t('common.night') }}
        </span>
    </div>
</template>

<script>
import { PRICE_TYPE_INCLUDED } from '~/config/productTypes';

export default {
    name: 'VehicleAddonPrice',
    props: {
        addon: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            PRICE_TYPE_INCLUDED,
        };
    },
};
</script>

<style scoped lang="scss">
@import '@/sass/_variables.scss';

.vehicle-addon-price {
    &__per-night {
        @include font-size(12px);

        &:before {
            content: '/';
            margin-left: 2px;
            @include font-size(16px);
        }
    }
}
</style>
